import axios from './axios';
import utils from '../libs/utils';

const MODULE_NAME = 'v1/ddi-web';
export default {
  axios,
  getRuleList(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/rule/list/condition?${utils.exchangeParams(params)}`);
  },
  getGoodsList(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/goods/list/condition?${utils.exchangeParams(params)}`);
  },
  getStoreList(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/store/list?${utils.exchangeParams(params)}`);
  },
  getTaskList(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/task/list/condition?${utils.exchangeParams(params)}`);
  },
  getRuleInfo(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/rule/id?${utils.exchangeParams(params)}`);
  },
  getTaskInfo(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/task/detail?${utils.exchangeParams(params)}`);
  },
  getHistoryUploadedData(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/file/list/condition?${utils.exchangeParams(params)}`);
  },
  downloadFile(params) {
    return `${axios.defaults.baseURL}${MODULE_NAME}/dataDirect/task/detail/download?${utils.exchangeParams(params)}`;
    // return axios.get(`${MODULE_NAME}/dataDirect/task/detail/download?${utils.exchangeParams(params)}`);
  },
  downloadData(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/task/detail/download?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  downloadHistory(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/task/history/download?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  addRule(params) {
    return axios.post(`${MODULE_NAME}/dataDirect/rule/add`, utils.exchangeParams(params));
  },
  addStore(params) {
    return axios.post(`${MODULE_NAME}/dataDirect/store/add`, utils.exchangeParams(params));
  },
  updateRule(params) {
    return axios.post(`${MODULE_NAME}/dataDirect/rule/update`, utils.exchangeParams(params));
  },
  uploadDataAndCheck(params) {
    return axios.post(`${MODULE_NAME}/dataDirect/task/execute`, utils.exchangeParams(params));
  },
  uploadData(params) {
    return axios.post(`${MODULE_NAME}/dataDirect/task/upload`, utils.exchangeParams(params));
  },
  forceUploadData(params) {
    return axios.post(`${MODULE_NAME}/dataDirect/task/force/upload`, utils.exchangeParams(params));
  },

  regenerateData(params) {
    return axios.post(`${MODULE_NAME}/dataDirect/task/data/regenerate`, utils.exchangeParams(params));
  },
  getStoreListByRuleId(params) {
    return axios.get(`${MODULE_NAME}/dataDirect/store/list/name?${utils.exchangeParams(params)}`);
  },
  // 非处方药流向记录查询
  getSalePrescriptionOTCList(params) {
    return axios.get(`/v1/erp-business-web/saleOrder/list/salePrescriptionOTC?${utils.exchangeParams(params)}`);
  },
  // 非处方药流向记录导出
  downloadSalePrescriptionOTC(params) {
    return axios.get(`/v1/erp-business-web/saleOrder/list/salePrescriptionOTC/download?${utils.exchangeParams(params)}`);
  },
};
